import React from 'react';
import PageDocumentTitle from '../PageDocumentTitle';
import PageHeader from '../PageHeader';
import PageRoot from '../PageRoot';

export default function WorkflowPageLayout({
    documentTitle,
    title,
    banners,
    filters,
    state,
    children,
    overlays,
}) {
    return (
        <PageRoot variant="workflow">
            <PageDocumentTitle title={documentTitle} />
            {banners}
            <div className="workflow-page__intro">
                <PageHeader title={title} variant="plain" />
                {filters && <div className="workflow-page__filters">{filters}</div>}
            </div>
            {state}
            {children}
            {overlays}
        </PageRoot>
    );
}
